import { DateTime } from 'luxon';
import { Months } from 'context';
import { getMonthsTranslated } from 'services/TranslationService';

export const TIME: { [key: string]: string } = {
  '21:00:00': '00:00',
  '22:00:00': '01:00',
  '23:00:00': '02:00',
  '00:00:00': '03:00',
  '01:00:00': '04:00',
  '02:00:00': '05:00',
  '03:00:00': '06:00',
  '04:00:00': '07:00',
  '05:00:00': '08:00',
  '06:00:00': '09:00',
  '07:00:00': '10:00',
  '08:00:00': '11:00',
  '09:00:00': '12:00',
  '10:00:00': '13:00',
  '11:00:00': '14:00',
  '12:00:00': '15:00',
  '13:00:00': '16:00',
  '14:00:00': '17:00',
  '15:00:00': '18:00',
  '16:00:00': '19:00',
  '17:00:00': '20:00',
  '18:00:00': '21:00',
  '19:00:00': '22:00',
  '20:00:00': '23:00',
};

export const parseDate = (date: string) =>
  `${DateTime.fromISO(date).day} ${getMonthsTranslated(
    Months[DateTime.fromISO(date, { locale: 'eng' }).monthLong as keyof typeof Months],
  )} ${DateTime.fromISO(date).year}, ${DateTime.fromISO(date).toLocaleString(
    DateTime.TIME_24_SIMPLE,
  )}`;

/**
 * Дата БЕЗ времени: «6 Wrzesień 2026».
 *
 * `parseDate` дописывает время, и для полей вида «активна до» это выглядело
 * ошибкой — у срока действия вакансии времени в данных нет вовсе
 * (`Vacancy.expires_at` — DateField), поэтому «00:00» было чистым артефактом.
 */
export const parseDateOnly = (date: string) =>
  `${DateTime.fromISO(date).day} ${getMonthsTranslated(
    Months[DateTime.fromISO(date, { locale: 'eng' }).monthLong as keyof typeof Months],
  )} ${DateTime.fromISO(date).year}`;

/**
 * Дата словами на языке интерфейса: «15 września 2026» / «15 сентября 2026».
 *
 * ТЗ 0071: карьерный раздел выводил сырые `2026-09-15` и
 * `toLocaleDateString()` без локали — в англоязычном браузере «9/15/2026».
 * `parseDateOnly` здесь не годится: он склеивает именительный падеж месяца
 * («6 Wrzesień 2026»), а по-польски и по-русски после числа нужен родительный.
 * Пустое или нечитаемое значение — пустая строка, а не «Invalid DateTime».
 */
export const formatCareerDate = (value: string | null | undefined): string => {
  if (!value) return '';
  const parsed = DateTime.fromISO(value);
  if (!parsed.isValid) return '';
  return parsed
    .setLocale(process.env.REACT_APP_LANG || 'ru')
    .toLocaleString({ day: 'numeric', month: 'long', year: 'numeric' });
};

export const parseDateFromDatePicker = (date: Date) =>
  `${DateTime.fromJSDate(date).day} ${getMonthsTranslated(
    Months[
      DateTime.fromISO(DateTime.fromJSDate(date).toISODate(), { locale: 'eng' })
        .monthLong as keyof typeof Months
    ],
  )} ${DateTime.fromJSDate(date).year}`;

export const isBeforeNow = (date: string) =>
  DateTime.fromISO(date).startOf('day') < DateTime.now().startOf('day');

export const parseLessonDay = (date: string) => {
  const parsedDate = DateTime.fromISO(date)
    .setLocale(process.env.REACT_APP_LANG || 'ru')
    .toFormat('EEEE, d');
  return `${parsedDate.charAt(0).toUpperCase() + parsedDate.slice(1)} ${getMonthsTranslated(
    Months[DateTime.fromISO(date, { locale: 'eng' }).monthLong as keyof typeof Months],
  )}`;
};

export const isNow = (date: string) => DateTime.now().toISODate() === date;

export const isTomorrow = (date: string) => DateTime.now().plus({ days: 1 }).toISODate() === date;

const date = new Date();

export default date;
